import {registerLocaleData} from '@angular/common'
import {provideHttpClient, withInterceptors} from '@angular/common/http'
import localeFr from '@angular/common/locales/fr'
import localeSv from '@angular/common/locales/sv'
import {ApplicationConfig, inject, provideAppInitializer} from '@angular/core'
import {MAT_CARD_CONFIG, MatCardConfig} from '@angular/material/card'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {MatPaginatorIntl} from '@angular/material/paginator'
import {provideRouter, withHashLocation} from '@angular/router'
import {
  authInterceptor,
  ConfigService,
  IConfig,
  SPB_LOGIN_SETTINGS,
  SPS_CONFIG
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {SpbPaginatorSv} from '@sparbanken-syd/sparbanken-syd-theme'
import {environment} from '../environments/environment'

import {routes} from './app.routes'
import {
  CUSTOMER_START,
  PORTFOLIO_MANAGER_ROLES,
  USER_ROLES
} from './application/constants'
import {responseInterceptor} from './application/response.interceptor'

registerLocaleData(localeFr)
registerLocaleData(localeSv)

const configServiceConfig: IConfig = {
  authServiceUrl: environment.authServiceUrl,
  domain: environment.domain,
  adminRoles: [
    ...USER_ROLES,
    ...PORTFOLIO_MANAGER_ROLES
  ]
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: SPS_CONFIG,
      useValue: configServiceConfig
    },
    {
      provide: SPB_LOGIN_SETTINGS, useValue: {
        text: 'Välkommen till investeringsrådgivning, för att använda tjänsten måste du identifiera dig',
        buttonText: 'Logga in med BankID',
        route: ['/', CUSTOMER_START]
      }
    },
    provideAppInitializer(() => inject(ConfigService).bootstrap()),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        responseInterceptor
      ])
    ),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {
        floatLabel: 'always',
      }
    },
    {provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'} as MatCardConfig},
    {provide: MatPaginatorIntl, useClass: SpbPaginatorSv},
  ]
}
